import { render, staticRenderFns } from "./processLib.vue?vue&type=template&id=123937a3&scoped=true"
import script from "./processLib.vue?vue&type=script&lang=js"
export * from "./processLib.vue?vue&type=script&lang=js"
import style0 from "./processLib.vue?vue&type=style&index=0&id=123937a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123937a3",
  null
  
)

export default component.exports